// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tX","ribbon":"tY","title":"tZ","genres":"t0"};